module.exports = __webpack_public_path__ + "static/media/icons8-multiply.13542480.svg";